import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { getAuth } from 'firebase/auth';
import { Observable, throwError } from 'rxjs';
import { environmentConfig } from '../../environment';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DynamicSQLService {
  private apiUrl = environmentConfig.apiBaseUrl;

  constructor(private http: HttpClient) { }

  private fetchAuthenticated(
    url: string,
    method: 'GET' | 'POST',
    token: string,
    bodyData?: any
  ): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    });

    const httpOptions = { headers };
    let httpCall: Observable<any>;

    if (method === 'GET') {
      httpCall = this.http.get(url, httpOptions);
    } else if (method === 'POST') {
      httpCall = this.http.post(url, bodyData, httpOptions);
    } else {
      return throwError(() => new Error('Unsupported method'));
    }

    return httpCall.pipe(
      catchError(error => {
        console.error('❌ HTTP Error:', error);
        return throwError(() => error);
      })
    );
  }

  sanitizeData(data: any): any {
    const fieldsToIgnore = ['data_type_data_type_name'];
    return Object.fromEntries(
      Object.entries(data)
        .filter(([k]) => !fieldsToIgnore.includes(k))
        .map(([k, v]) => [k, v === null ? "" : v])
    );
  }

  getTableInfo(tableName: string, token: string): Observable<any[]> {
    const url = `${this.apiUrl}/api/dynamicsqlgrid/gettableinfo/${tableName}`;
    return this.fetchAuthenticated(url, 'GET', token);
  }

  getViewInfo(viewName: string, token: string): Observable<any[]> {
    const url = `${this.apiUrl}/api/dynamicsqlgrid/getviewinfo/${viewName}`;
    return this.fetchAuthenticated(url, 'GET', token);
  }

  getTableData(tableName: string, token: string): Observable<any> {
    const url = `${this.apiUrl}/api/dynamicsqlgrid/${tableName}`;
    return this.fetchAuthenticated(url, 'GET', token);
  }

  getDropdownOptionsForColumn(tableName: string, refTable: string, refColumn: string, token: string, refWhere?: string, refJoin?: string
  ): Observable<any[]> {
    let url = `${this.apiUrl}/api/dynamicsqlgrid/dropdownoptionsbycolumn/${tableName}/${refTable}/${refColumn}`;
    if (refWhere || refJoin) {
      const queryParams: string[] = [];
      if (refWhere) queryParams.push(`refWhere=${encodeURIComponent(refWhere)}`);
      if (refJoin) queryParams.push(`refJoin=${encodeURIComponent(refJoin)}`);
      url += `?${queryParams.join('&')}`;
    }
    return this.fetchAuthenticated(url, 'GET', token);
  }

  // getDropdownOptionsForColumn(tableName: string, columnName: string, token: string): Observable<any[]> {
  //   const url = `${this.apiUrl}/api/dynamicsqlgrid/dropdownoptionsbycolumn/${tableName}/${columnName}`;
  //   return this.fetchAuthenticated(url, 'GET', token);
  // }

  insertItem(userID: string, tableName: string, key_val_pairs: any, token: string): Observable<any> {
    const url = `${this.apiUrl}/api/dynamicsqlgrid/insert/${tableName}/${userID}`;
    const payload = this.sanitizeData(key_val_pairs); // ✅ remove the wrapping object
    return this.fetchAuthenticated(url, 'POST', token, payload);
  }

  updateItem(userID: string, tableName: string, data: any, id: number, token: string): Observable<any> {
    const url = `${this.apiUrl}/api/dynamicsqlgrid/edit/${tableName}/${id}/${userID}`;
    const { id: _, ...dataWithoutId } = data;
    const payload = { key_val_pairs: this.sanitizeData(dataWithoutId) }; // ✅ WRAP it
    return this.fetchAuthenticated(url, 'POST', token, payload);
  }

  deleteItem(tableName: string, id: number, token: string): Observable<any> {
    const url = `${this.apiUrl}/api/dynamicsqlgrid/delete/${tableName}/${id}`;
    const payload = { id };
    return this.fetchAuthenticated(url, 'POST', token, payload);
  }

  // getViewData(viewName: string, token: string): Observable<any> {
  //   const url = `${this.apiUrl}/api/getview/${viewName}`;
  //   return this.fetchAuthenticated(url, 'GET', token);
  // }

  getViewData(viewName: string, token: string): Observable<any> {
    const url = `${this.apiUrl}/api/getview/${viewName}`;
    return this.fetchAuthenticated(url, 'GET', token);
  }

  getBaseTableCols(table: string, token: string): Observable<any> {
    const url = `${this.apiUrl}/api/dynamicsqlgrid/basecols?table=${table}`;
    return this.fetchAuthenticated(url, 'GET', token);
  }

  //NOT PART OF GRID!!!!!!!!!!!!!! DO NOT USE IN GRID
  updateTableInfo(tableName: string, token: string): Observable<any> {
    const url = `${this.apiUrl}/api/dynamicsqlgrid/update-table-info/${tableName}`;
    const payload = { tableName };
    return this.fetchAuthenticated(url, 'POST', token, payload);
  }
}
